<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row">
                    <div class="col-md-12">
                        <a class="mt-3 mb-3 d-block" @click="$router.replace({name: 'DocumentDetails', params: {id: nodeData.id}})">
                            <i class="fa fa-chevron-circle-left"></i> Nazaj
                        </a>
                    </div>
                </div>

                <div class="row" v-if="Object.keys(nodeData).length > 0">

                    <div class="col-md-12">

                        <h2 class="preventLongStringOutbreak">
                            <i :class="$globalFunctions.getFileTypeIcon(nodeData.content.mimeType)"></i> {{nodeData.properties["cm:title"]}}
                        </h2>
                        <h6>
                            <b>Originalno ime: {{nodeData.properties["rma:origionalName"] ? nodeData.properties["rma:origionalName"] : '/'}}</b>
                        </h6>
                        <p class="mb-3">
                            <small><i class="fa fa-calendar text-black-50"></i>
                                {{moment(nodeData.modifiedAt).local().format("DD. MM. YYYY HH:mm:ss")}} <span
                                        class="text-black-50">|</span> <i class="fa fa-user text-black-50"></i>
                                {{nodeData.modifiedByUser.displayName}}</small>
                        </p>
                    </div>

                </div>

                <div class="row">

                    <loading :active.sync="isLoading"
                             :can-cancel="false"
                             :is-full-page="false"></loading>


                    <div class="col-md-8 mb-5">

                        <div class="row" v-if="Object.keys(nodeData).length > 0">
                            <div class="col-md-12 form-condensed">

                                <div class="p-4 bg-light">
                                    <h4>Podatki o dokumentu</h4>



                                    <div class="form-group">
                                        <label for="title">Naslov</label>
                                        <input type="text" class="form-control" id="title"
                                               aria-describedby="title"
                                               v-model="nodeData.properties['cm:title']"
                                               name="title"
                                               :class="{'is-invalid': errors.title}"
                                        >
                                        <div class="invalid-feedback"
                                             v-if="errors.title">
                                            Polje Naslov je obvezno.
                                        </div>
                                    </div>



                                    <div class="form-group">
                                        <label for="description">Kratek opis vsebine</label>
                                        <textarea class="form-control" id="description"
                                                  aria-describedby="description"
                                                  v-model="nodeData.properties['cm:description']"
                                                  name="description"
                                                  :class="{'is-invalid': errors.description}"
                                        ></textarea>
                                        <div class="invalid-feedback"
                                             v-if="errors.description">
                                            Polje Opis je obvezno.
                                        </div>
                                    </div>


                                    <div class="form-group">
                                        <label for="author">Avtor</label>
                                        <input type="text" class="form-control" id="author"
                                               aria-describedby="author"
                                               v-model="nodeData.properties['cm:author']"
                                               name="author"
                                               :class="{'is-invalid': errors.author}"
                                        >
                                        <div class="invalid-feedback"
                                             v-if="errors.author">
                                            Polje Avtor je obvezno.
                                        </div>
                                    </div>





                                    <div>

                                        <div class="form-group">
                                            <label for="mimetype">Vrsta dokumenta</label>
                                            <input type="text" class="form-control" id="mimetype"
                                                   aria-describedby="mimetype"
                                                   :placeholder="nodeData.content.mimeType"
                                                   disabled
                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="size">Velikost datoteke</label>
                                            <input type="text" class="form-control" id="size"
                                                   aria-describedby="size"
                                                   :placeholder="nodeData.content.sizeInBytes | prettyBytes"
                                                   disabled
                                            />
                                        </div>


                                        <div class="form-group">
                                            <label for="createdAt"> Datum in ura zajema enote gradiva</label>
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    id="createdAt"
                                                    aria-describedby="createdAt"
                                                    :placeholder="moment(nodeData.createdAt).local().format('DD. MM. YYYY HH:mm:ss')"
                                                    disabled

                                            />
                                        </div>

                                    </div>
                                </div>

                                <hr/>


                                <div v-for="(aspect, index) in eHrambaAspectsDictionary" :key="index" v-if="(!nodeData.properties['EH:komponenta_povezave_na_dokumente'] || (nodeData.properties['EH:komponenta_povezave_na_dokumente']
                                && aspect.name === 'EH:komponenta')) && aspect.title !== 'E-podpis' && aspect.name !== 'EH:verzioniranje' && aspect.name !== 'EH:verzija_type' && aspect.name !== 'EH:verzija' && aspect.name !== 'EH:porocilo'
                                && aspect.name !== 'EH:pretvorjeno_gradivo' && aspect.name !== 'EH:pretvorba_za_dolgorocno_hrambo' && aspect.name !== 'EH:pretvorjeno_gradivo_assoc_aspect'">

                                    <div class="p-4 bg-light">
                                        <h4>{{aspect.title}}</h4>

                                        <div v-for="property in aspect.properties"
                                             :class="property.dataType === 'd:boolean' ? 'form-check' : 'form-group'">

                                            <!--                                            {{property}}-->

                                            <b-row>
                                                <div class="col-md-11">
                                                    <input v-if="property.dataType === 'd:boolean'" type="checkbox"
                                                           class="form-check-input"
                                                           :id="property.name"
                                                           v-model="nodeData.properties[property.name]"
                                                           :disabled="disabledFieldsEditMode.includes(property.name)"
                                                    >
                                                </div>
                                                <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]">
                                                    <input type="checkbox" v-if="property.dataType === 'd:boolean'"
                                                           class="form-check-input"
                                                           :id="property.name"
                                                           v-model="isPropertyChecked[property.name]"
                                                           :disabled="disabledFieldsEditMode.includes(property.name)"
                                                    >
                                                </div>


                                            </b-row>

                                            <label :for="property.name">{{property.title}}<span
                                                    v-if="markedFieldsAddMode.includes(property.name)">**</span><small
                                                    class="text-black-50">(typ:
                                                {{property.dataType}}, id: <i class="fa fa-info" :title="property.name"></i>)</small></label>

                                            <div v-if="checkIfCodeList(property.name)">

                                                <div v-if="property.name === 'EH:rok_hrambe'">

                                                    <b-row>
                                                        <div class="col-md-11">
                                                            <v-select
                                                                    class="form-control"
                                                                    v-model="nodeData.properties[property.name]"
                                                                    :id="property.name"
                                                                    :name="property.name"
                                                                    :options="getCodeListOptions(property.name)"
                                                                    label="explanation"
                                                                    :reduce="item => item.id"
                                                                    :disabled="disabledFieldsEditMode.includes(property.name)">
                                                                <span slot="no-options">Ni zadetkov.</span>
                                                            </v-select>
                                                        </div>
                                                        <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]">
                                                            <input type="checkbox"
                                                                   class="form-check-input"
                                                                   :id="property.name"
                                                                   :disabled="disabledFieldsEditMode.includes(property.name)"
                                                                   v-model="isPropertyChecked[property.name]"
                                                            >
                                                        </div>


                                                    </b-row>

                                                </div>
                                                <div v-else >

                                                    <div v-if="property.name === 'EH:status_gradiva'">

                                                        <b-row>
                                                            <div class="col-md-11">
                                                                <v-select
                                                                        class="form-control"
                                                                        v-model="nodeData.properties[property.name]"
                                                                        :id="property.name"
                                                                        :name="property.name"
                                                                        :options="getCodeListOptions(property.name)"
                                                                        label="description"
                                                                        :reduce="item => item.id"
                                                                        :disabled="disabledFieldsEditMode.includes(property.name) || initialDocumentStatus == 3">
                                                                    <span slot="no-options">Ni zadetkov.</span>
                                                                </v-select>
                                                            </div>
                                                            <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]">
                                                                <input type="checkbox"
                                                                       class="form-check-input"
                                                                       :id="property.name + 'checkbox'"
                                                                       :disabled="disabledFieldsEditMode.includes(property.name) || initialDocumentStatus == 3"
                                                                       v-model="isPropertyChecked[property.name]"
                                                                >
                                                            </div>

                                                        </b-row>


                                                        <div v-if="initialDocumentStatus == 3">

                                                            <div class="row">
                                                                <div class="col-md-6">

                                                                    <button id="status_delovni" class="btn btn-sm btn-secondary mt-2"
                                                                            @click="changeDocumentStatus(1)"
                                                                    >Spremeni status gradiva v delovni
                                                                    </button>

                                                                </div>
                                                                <div class="col-md-6">
                                                                    <button id="status_koncni" class="btn btn-sm btn-secondary mt-2"
                                                                            @click="changeDocumentStatus(2)"
                                                                    >Spremeni status gradiva v končni
                                                                    </button>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                    <div v-else>

                                                        <b-row>
                                                            <div class="col-md-11">
                                                                <v-select
                                                                        class="form-control"
                                                                        v-model="nodeData.properties[property.name]"
                                                                        :id="property.name"
                                                                        :name="property.name"
                                                                        :options="getCodeListOptions(property.name)"
                                                                        label="description"
                                                                        :reduce="item => item.id"
                                                                        :disabled="disabledFieldsEditMode.includes(property.name)">
                                                                    <span slot="no-options">Ni zadetkov.</span>
                                                                </v-select>
                                                            </div>
                                                            <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]">
                                                                <input type="checkbox"
                                                                       class="form-check-input"
                                                                       :id="property.name"
                                                                       :disabled="disabledFieldsEditMode.includes(property.name)"
                                                                       v-model="isPropertyChecked[property.name]"
                                                                >
                                                            </div>


                                                        </b-row>

                                                    </div>

                                                </div>

                                            </div>
                                            <div v-else>


                                                <b-row>

                                                    <div class="col-md-11">
                                                        <input v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name !== 'EH:klasifikacijska_oznaka_razreda'  && property.name !== 'EH:komponenta_povezave_na_dokumente'"
                                                               type="text" class="form-control" :id="property.name"
                                                               v-model="nodeData.properties[property.name]"
                                                               :disabled="disabledFieldsEditMode.includes(property.name)"

                                                        >
                                                    </div>
                                                    <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]">
                                                        <input type="checkbox"  v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name !== 'EH:klasifikacijska_oznaka_razreda'  && property.name !== 'EH:komponenta_povezave_na_dokumente'"
                                                               class="form-check-input"
                                                               :id="property.name"
                                                               :disabled="disabledFieldsEditMode.includes(property.name)"
                                                               v-model="isPropertyChecked[property.name]"
                                                        >
                                                    </div>


                                                </b-row>

                                                <b-row>
                                                    <div class="col-md-11">
                                                        <!-- klasifikacijska oznaka razreda-->
                                                        <input v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name === 'EH:klasifikacijska_oznaka_razreda' && property.name !== 'EH:komponenta_povezave_na_dokumente'"
                                                               type="text" class="form-control" :id="property.name"
                                                               v-model="nodeData.properties[property.name]"
                                                               :disabled="disabledFieldsEditMode.includes(property.name)"
                                                        />
                                                    </div>
                                                    <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]">
                                                        <input type="checkbox"  v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name === 'EH:klasifikacijska_oznaka_razreda' && property.name !== 'EH:komponenta_povezave_na_dokumente'"
                                                               class="form-check-input"
                                                               :id="property.name"
                                                               :disabled="disabledFieldsEditMode.includes(property.name)"
                                                               v-model="isPropertyChecked[property.name]"
                                                        >
                                                    </div>


                                                </b-row>
                                              <b-row v-if="nodeData.properties['EH:status_gradiva'] === 3 && property.name === 'EH:klasifikacijska_oznaka_razreda' && property.name !== 'EH:komponenta_povezave_na_dokumente'">
                                                <b-col lg="12">

                                                  <div>
                                                    <button id="status_delovni" class="btn btn-sm btn-secondary mt-2" v-if="!showPremestitevArhiviraneEnoteGradiva"
                                                            @click="() => { showPremestitevArhiviraneEnoteGradiva = true;}"
                                                    >Premestitev enote gradiva v statusu ARHIVIRAN v drug razred
                                                    </button>

                                                    <div v-if="showPremestitevArhiviraneEnoteGradiva">
                                                      <label>ID oznaka novega razreda</label>
                                                    <b-input
                                                           type="text" class="form-control"
                                                           v-model="premestitevArhiviraneEnoteNovRazred"
                                                    />
                                                    </div>

                                                    <button id="status_delovni" class="btn btn-sm btn-primary mt-2" v-if="showPremestitevArhiviraneEnoteGradiva" :disabled="premestitevArhiviraneEnoteNovRazred === null || premestitevArhiviraneEnoteNovRazred === ''" :class="premestitevArhiviraneEnoteNovRazred === null || premestitevArhiviraneEnoteNovRazred === '' ? 'disabled' : ''"
                                                            @click="() => { premestiArhiviranoEnotoGradiva(); }"
                                                    >Premestitev enote gradiva v statusu v razred {{premestitevArhiviraneEnoteNovRazred}}
                                                    </button>
                                                  </div>
                                                </b-col>
                                              </b-row>


                                                <b-row>
                                                    <div class="col-md-11">
                                                        <vue-tags-input v-if="property.dataType === 'd:text' && property.name === 'EH:komponenta_povezave_na_dokumente'"
                                                                        :id="aspect.properties['EH:komponenta_povezave_na_dokumente'].name"
                                                                        v-model="componentTag"
                                                                        :tags="componentTags"
                                                                        placeholder="vpiši ID gradiva in pritisni Enter"
                                                                        style="max-width: initial"
                                                                        @tags-changed="newTags => {componentTags = newTags; onComponentTagsChanged(newTags)}"
                                                        />
                                                    </div>
                                                    <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]">
                                                        <input type="checkbox" v-if="property.dataType === 'd:text' && property.name === 'EH:komponenta_povezave_na_dokumente'"
                                                               class="form-check-input"
                                                               :id="property.name"
                                                               :disabled="disabledFieldsEditMode.includes(property.name)"
                                                               v-model="isPropertyChecked[property.name]"
                                                        >
                                                    </div>


                                                </b-row>

                                                <b-row>
                                                    <div class="col-md-11">
                                                        <input v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"
                                                               type="number"
                                                               class="form-control" :id="property.name"
                                                               v-model="nodeData.properties[property.name]"
                                                               :disabled="disabledFieldsEditMode.includes(property.name)"

                                                        >
                                                    </div>
                                                    <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]">
                                                        <input type="checkbox"  v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"
                                                               class="form-check-input"
                                                               :id="property.name"
                                                               :disabled="disabledFieldsEditMode.includes(property.name)"
                                                               v-model="isPropertyChecked[property.name]"
                                                        >
                                                    </div>


                                                </b-row>

                                                <b-row>
                                                    <div class="col-md-11">
                                                        <div v-if="property.dataType == 'd:datetime'">
                                                            <div v-if="disabledFieldsEditMode.includes(property.name)">
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        :id="property.name"
                                                                        :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).local().format('DD. MM. YYYY HH:mm:ss') : ''"
                                                                        disabled
                                                                />
                                                            </div>
                                                            <div v-else>
                                                                <VueCtkDateTimePicker
                                                                        :id="property.name"
                                                                        format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                                        formatted="DD.MM.YYYY, HH:mm"
                                                                        v-model="nodeData.properties[property.name]"
                                                                        locale="sl"
                                                                        :noLabel="true"
                                                                        :button-now-translation="$t('text.globals.now')"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]" >
                                                        <input type="checkbox"  v-if="property.dataType == 'd:datetime'"
                                                               class="form-check-input"
                                                               :id="property.name"
                                                               :disabled="disabledFieldsEditMode.includes(property.name)"
                                                               v-model="isPropertyChecked[property.name]"
                                                        >
                                                    </div>


                                                </b-row>

                                                <b-row>
                                                    <div class="col-md-11">
                                                        <div v-if="property.dataType == 'd:date'">
                                                            <div v-if="disabledFieldsEditMode.includes(property.name)">
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        :id="property.name"
                                                                        :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).local().format('DD. MM. YYYY') : ''"
                                                                        disabled

                                                                />
                                                            </div>
                                                            <div v-else>
                                                                <VueCtkDateTimePicker
                                                                        :id="property.name"
                                                                        format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                                        formatted="DD.MM.YYYY"
                                                                        :onlyDate="true"
                                                                        :noLabel="true"
                                                                        v-model="nodeData.properties[property.name]"
                                                                        locale="sl"
                                                                        :button-now-translation="$t('text.globals.now')"

                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1" v-if="!isPropertyCheckboxDisabled[property.name]" >
                                                        <input type="checkbox"  v-if="property.dataType == 'd:date'"
                                                               class="form-check-input"
                                                               :id="property.name"
                                                               :disabled="disabledFieldsEditMode.includes(property.name) || isPropertyCheckboxDisabled[property.name]"
                                                               v-model="isPropertyChecked[property.name]"
                                                        >
                                                    </div>


                                                </b-row>

                                            </div><!-- end of else -->

                                        </div>

                                    </div>

                                    <hr/>



                                </div>

                                <div v-for="(aspect, index) in eHrambaAspectsDictionary" :key="index"
                                     v-if="(!nodeData.properties['EH:komponenta_povezave_na_dokumente'] || (nodeData.properties['EH:komponenta_povezave_na_dokumente'] && aspect.name === 'EH:komponenta')) && aspect.title === 'E-podpis'">


                                    <div class="p-4 bg-light">
                                        <h4>{{aspect.title}}</h4>

                                        <div v-for="(property,_index) in aspect.properties"
                                             v-if="property.name === 'EH:stevilo_podpisov'"
                                             :class="property.dataType === 'd:boolean' ? 'form-check' : 'form-group'"
                                             :key="'property_' + _index">


                                            <label :for="property.name">{{property.title}}<span
                                                    v-if="markedFieldsAddMode.includes(property.name)">**</span><small
                                                    class="text-black-50">(typ:
                                                {{property.dataType}}, id: <i class="fa fa-info"
                                                                              :title="property.name"></i>)</small></label>


                                            <input v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"
                                                   type="number"
                                                   class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="disabledFieldsEditMode.includes(property.name)"
                                            >

                                        </div>

                                        E-podpisi ({{podpisi.length}})

                                        <div v-if="podpisi.length === 0" class="py-2">
                                            <em><i class="fa fa-exclamation-triangle"></i> Ni dodanih podpisov.</em>
                                        </div>

                                        <div class="table-responsive" v-if="podpisi.length > 0">
                                            <table class="table">
                                                <thead>
                                                <tr>
                                                    <th>polje</th>
                                                    <th v-for="(podpis,idx) in podpisi">vrednost za #{{idx+1}}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(property,_index,idx) in aspect.properties"
                                                    v-if="property.name !== 'EH:stevilo_podpisov'">
                                                    <td>{{property.title}}</td>
                                                    <td v-for="(podpis) in podpisi">

                                                        {{podpis[property.name]}}

                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td>akcije</td>
                                                    <td v-for="(podpis,_idx) in podpisi">
                                                        <a class="btn btn-sm btn-block text-white btn-danger"
                                                           @click="() => { removeEsignature(_idx)}"><i
                                                                class="fa fa-trash"></i> Odstrani</a>
                                                        <a class="btn btn-sm btn-block text-white btn-info"
                                                           @click="() => { editEsignature(_idx)}"><i
                                                                class="fa fa-edit"></i> Uredi</a>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>


                                        <div v-for="(property,_index) in aspect.properties"
                                             :class="property.dataType === 'd:boolean' ? 'form-check' : 'form-group'"
                                             v-if="property.name !== 'EH:stevilo_podpisov' && !eSignatureDataReadyForPost"
                                             :key="'property_' + _index">


                                            <input v-if="property.dataType === 'd:boolean'" type="checkbox"
                                                   class="form-check-input"
                                                   :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="disabledFieldsEditMode.includes(property.name)"
                                            >

                                            <label :for="property.name">{{property.title}}<span
                                                    v-if="markedFieldsAddMode.includes(property.name)">**</span><small
                                                    class="text-black-50">(typ:
                                                {{property.dataType}}, id: <i class="fa fa-info"
                                                                              :title="property.name"></i>)</small></label>


                                            <input v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name !== 'EH:klasifikacijska_oznaka_razreda' && property.name !== 'EH:povezave_na_vodilne_dokumente' && (!property.name.includes('datum') && !property.name.includes('cas') && !property.name.includes('velja'))"
                                                   type="text" class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="disabledFieldsEditMode.includes(property.name)"

                                            >

                                            <!-- klasifikacijska oznaka razreda-->
                                            <input v-if="property.dataType === 'd:text' && property.name === 'EH:klasifikacijska_oznaka_razreda'"
                                                   type="text" class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && disabledFieldsEditMode.includes(property.name)"
                                                   @input="allowOnlyNumbers(property.name)"

                                            />


                                            <input v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"
                                                   type="number"
                                                   class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="disabledFieldsEditMode.includes(property.name)"

                                            >


                                            <div v-if="property.dataType == 'd:datetime' || ((property.dataType === 'd:text' || property.dataType === 'd:mltext') && (property.name.includes('datum') || property.name.includes('cas') || property.name.includes('velja')))">
                                                <div v-if="disabledFieldsEditMode.includes(property.name)">
                                                    <input
                                                            type="text"
                                                            class="form-control"
                                                            :id="property.name"
                                                            :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).local().format('DD. MM. YYYY HH:mm:ss') : ''"
                                                            disabled
                                                    />
                                                </div>
                                                <div v-else>
                                                    <VueCtkDateTimePicker
                                                            :id="property.name"
                                                            @input="selectDate"
                                                            format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                            formatted="DD.MM.YYYY, HH:mm:ss"
                                                            v-model="nodeData.properties[property.name]"
                                                            locale="sl"
                                                            :noLabel="true"
                                                            :button-now-translation="$t('text.globals.now')"
                                                    />
                                                </div>
                                            </div>


                                            <div v-if="property.dataType == 'd:date'">
                                                <div v-if="disabledFieldsEditMode.includes(property.name)">
                                                    <input
                                                            type="text"
                                                            class="form-control"
                                                            :id="property.name"
                                                            :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).local().format('DD. MM. YYYY') : ''"
                                                            disabled

                                                    />
                                                </div>
                                                <div v-else>
                                                    <VueCtkDateTimePicker
                                                            :id="property.name"
                                                            @input="selectDate"
                                                            format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                            formatted="DD.MM.YYYY"
                                                            :onlyDate="true"
                                                            :noLabel="true"
                                                            v-model="nodeData.properties[property.name]"
                                                            locale="sl"
                                                            :button-now-translation="$t('text.globals.now')"
                                                    />
                                                </div>
                                            </div>


<!--                                            <small class="text-danger"-->
<!--                                                   v-if="$v.nodeData.properties[property.name] && $v.nodeData.properties[property.name].$error">-->
<!--                                                <span v-if="$v.nodeData.properties[property.name].hasOwnProperty('required') && !$v.nodeData.properties[property.name].required">Polje ne sme biti prazno.</span>-->
<!--                                                <span v-if="$v.nodeData.properties[property.name].hasOwnProperty('numeric') && !$v.nodeData.properties[property.name].numeric">Vrednost mora biti številka.</span>-->
<!--                                            </small>-->

                                        </div>

                                        <div class="mt-3">
                                            <a class="btn btn-primary text-white" v-if="!eSignatureEditMode"
                                               @click="addEsignature()"><i class="fa fa-plus"></i> Dodaj e-podpis</a>
                                            <a class="btn btn-primary text-white" v-if="eSignatureEditMode"
                                               @click="updateEsignature()"><i class="fa fa-save"></i> Shrani spremembe v
                                                e-podpisu</a>
                                            <a class="btn btn-secondary text-white" v-if="eSignatureEditMode"
                                               @click="cancelEditingEsignature()">Prekliči urejanje e-podpisa</a>
                                            <!--  <a class="btn btn-link" @click="prepareEsignatureDataForPost()">Prepare data for post</a>-->
                                        </div>

                                    </div>

                                    <hr/>

                                </div>




                                <div class="p-4 bg-light">
                                    <h4>Uporabnik</h4>

                                    <div class="form-group">
                                        <label for="alfrescoUser">alfrescoUser</label>
                                        <input type="text" class="form-control" id="alfrescoUser"
                                               aria-describedby="alfrescoPassword"
                                               v-model="nodeData.alfrescoUser"

                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="alfrescoPassword">alfrescoPassword</label>
                                        <input type="text" class="form-control" id="alfrescoPassword"
                                               aria-describedby="alfrescoPassword"
                                               v-model="nodeData.alfrescoPassword"

                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="externalUserType">externalUserType</label>
                                        <v-select class="form-control" :options="['up_varnostne_sheme','up_s_certifikatom']" id="externalUserType"
                                                  v-model="nodeData.externalUserType">
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </div>

                                    <div class="form-group">
                                        <label for="externalUserId">externalUserId</label>
                                        <input type="text" class="form-control" id="externalUserId"
                                               aria-describedby="externalUserId"
                                               v-model="nodeData.externalUserId"

                                        />
                                    </div>

                                    <hr/>

                                    <div class="form-group">
                                        <label for="externalUserCertId">externalUserCertId</label>
                                        <input type="text" class="form-control" id="externalUserCertId"
                                               aria-describedby="externalUserCertId"
                                               v-model="nodeData.externalUserCertId"

                                        />
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-md-12 mt-3">

                                        <button class="btn btn-secondary"
                                                @click="$router.replace({name: 'DocumentDetails', params: {id: nodeData.id}})">
                                            Opusti spremembe
                                        </button>

                                        <b-button id="uploadNewFileVersionButton1" class="float-right mr-0"
                                                  variant="primary" @click="save"><i
                                                class="fas fa-save"></i>
                                                Shrani spremembe
                                        </b-button>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import SidebarNavigation from '../components/SidebarNavigation';
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import {required, minLength, between, email, numeric} from 'vuelidate/lib/validators'
    import pdf from 'vue-pdf'
    import VueTagsInput from '@johmun/vue-tags-input';


    export default {
        name: 'DocumentDetailsEdit',
        components: {
            SidebarNavigation,
            Loading,
            vSelect,
            pdf,
            VueTagsInput
        },

        data() {
            return {
                fileId: this.$route.params.id,

                componentTag: '',
                componentTags: [],
                linksToLeadingDocumentTag: '',
                linksToLeadingDocumentTags: [],
                allMetadataOptions: this.$store.getters.getAllMetadataOptions,
                isPropertyChecked: {},
                isPropertyCheckboxDisabled: {},
                nodeData: {
                    "isFile": true,
                    "createdByUser": {
                        "id": "",
                        "displayName": ""
                    },
                    "modifiedAt": "",
                    "nodeType": "cm:content",
                    "content": {
                        "mimeType": "",
                        "mimeTypeName": "",
                        "sizeInBytes": 0,
                        "encoding": "UTF-8"
                    },
                    "parentId": "",
                    "aspectNames": [
                        "cm:versionable",
                        "rmc:rmarecordCustomProperties",
                        "EH:osnovni_podatki",
                        "rma:recordComponentIdentifier",
                        "rma:commonRecordDetails",
                        "cm:ownable",
                        "cm:titled",
                        "rma:filePlanComponent",
                        "cm:auditable",
                        "rma:record",
                        "EH:e_podpis",
                        "EH:dodatni_podatki",
                        "rn:renditioned",
                        "EH:klasifikacija",
                        "cm:taggable",
                        "rma:dispositionLifecycle",
                        "cm:thumbnailModification",
                        "rma:recordOriginatingDetails",
                        "EH:hramba",
                        "rmc:customSupplementalMarkingList",
                        "EH:oznaka_zadeve",
                        "cm:author",
                        "rma:recordSearch",
                        'EH:premikanje_med_sistemi',
                    ],
                    "createdAt": "",
                    "isFolder": false,
                    modifiedByUser: {
                        "id": "",
                        displayName: ""
                    },
                    "name": "",
                    "id": "",
                    "properties": {},
                    propertiesToBeDeleted: [],
                    types: []
                },
                isLoading: true,
                isLoadingPreview: true,
                initialDocumentStatus: null,
                alfrescoDictionary: null,
                eHrambaAspectsDictionary: null,

                disabledFieldsEditMode: [
                    /*
                    'EH:status_pretvorbe_v_obliko_za_dolgorocno_hrambo',
                    //'EH:rok_hrambe',
                    'EH:datum_zacetka_teka_roka_hrambe',
                    'EH:oblika_gradiva_po_PETZ',
                    'EH:datum_zadnje_spremembe_statusa_gradiva',
                    'EH:mesto_hrambe',
                    'EH:status_pretvorbe_v_obliko_za_dolgotrajno_hrambo',
                    'EH:klasifikacijska_oznaka_razreda',
                    'EH:ID_zadeve',
                    'EH:oznaka_vpisnika',
                    'EH:oznaka_povezanega_sistema',
                    'EH:opravilna_stevilka_zadeve',
                    'EH:sodisce',
                    'EH:trajanje_roka_hrambe',
                    'EH:tip_gradiva',
                    'EH:povezave_na_vodilne_dokumente',
                    'EH:komponenta_povezave_na_dokumente'
                    */
                ],

                markedFieldsAddMode: [
                    'EH:rok_hrambe',
                    'EH:datum_zacetka_teka_roka_hrambe',
                    'EH:oblika_gradiva_po_PETZ',
                    'EH:datum_zadnje_spremembe_statusa_gradiva',
                    'EH:mesto_hrambe',
                    'EH:format_gradiva_preverjen',
                    'EH:format_datum_preverbe',
                    'EH:koncni_format',
                    'EH:format_ustrezen',
                    'EH:po_za_konverzijo',
                    'EH:izvorna_oblika',
                    'EH:trajanje_roka_hrambe'
                ],

                eSignatureEditMode: false,
                eSignatureItemInEdit: null,
                eSignatureDataReadyForPost: false,
                podpisi: [],
                eSignatureDeleted: false, // we use this to flag removing of signatures
                showPremestitevArhiviraneEnoteGradiva: false,
                premestitevArhiviraneEnoteNovRazred: null
            };
        },


        beforeCreate: function () {
            document.body.className = 'dashboard';
        },

        mounted() {

            this.$store.dispatch("retrieveAlfrescoDictionary").then(() => {


                this.alfrescoDictionary = this.$store.getters.getAlfrescoDictionary;
                console.log("alfresco dictionary: ", this.alfrescoDictionary);

                this.eHrambaAspectsDictionary = this.$store.getters.geteHrambaAlfrescoDictionary;
                console.log("aspectsDictionary", this.eHrambaAspectsDictionary);


                if (this.$store.getters.getAllMetadataOptions.length === 0) {
                    this.$store.dispatch('retrieveAllMetadataOptions').then(() => {
                        this.allMetadataOptions = this.$store.getters.getAllMetadataOptions;
                    })
                }
                console.log("allMetadataOptions", this.allMetadataOptions);
                this.getNode(this.fileId);


            });



        },

        computed: {

        },
        methods: {

            addEsignature() {
                const _this = this;

                _this.initEsignatureData();
                let podpis = {};

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            if(_k !== 'EH:stevilo_podpisov') {
                                podpis[_k] = _this.nodeData.properties[_k];
                            }
                        });
                    }
                });

                _this.podpisi.push(podpis);

                _this.cancelEditingEsignature();
            },

            removeEsignature(idx) {
                const _this = this;

                _this.eSignatureDeleted = true;
                _this.podpisi.splice(idx,1);
            },

            editEsignature(idx) {
                const _this = this

                _this.initEsignatureData();
                _this.cancelEditingEsignature();

                let signature = _this.podpisi[idx];
                _this.eSignatureItemInEdit = idx;
                _this.eSignatureEditMode = true;

                _.forOwn(_this.podpisi[idx], function (v, k) {
                    _this.nodeData.properties[k] = v;
                });

                console.log("signature", signature);
            },

            cancelEditingEsignature() {
                const _this = this;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            if(_k !== 'EH:stevilo_podpisov') {
                                _this.nodeData.properties[_k] = '';
                            }
                        });
                    }
                });

                _this.eSignatureEditMode = false;
                _this.eSignatureItemInEdit = null;
            },

            updateEsignature() {
                const _this = this;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            _this.podpisi[_this.eSignatureItemInEdit][_k] = _this.nodeData.properties[_k];
                        });
                    }
                });

                _this.cancelEditingEsignature();
            },

            initEsignatureData() {
                const _this = this;

                _this.eSignatureDataReadyForPost = false;

                // TODO: should we reset field here?
                // _.map(_this.eHrambaAspectsDictionary, function(v, k){
                //     if(v.name === 'EH:e_podpis') {
                //         _.map(v.properties, function(_v, _k){
                //             if(_k !== 'EH:stevilo_podpisov') {
                //                 console.log(_v);
                //                 // podpis[_k] = _this.nodeData.properties[_k];
                //             }
                //         });
                //     }
                // });

            },

            prepareEsignatureDataForPost() {
                const _this = this;

                _this.eSignatureDataReadyForPost = true;
                _this.eSignatureEditMode = false;
                _this.eSignatureItemInEdit = null;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k, idx){
                            if(_k !== 'EH:stevilo_podpisov') {
                                _this.nodeData.properties[_k] = [];
                            }
                        });
                    }
                });


                _.map(_this.podpisi, function(v, k){
                    _.forOwn(v, function (_v, _k) {
                        console.log("_k", _k);
                        console.log("_v", _v);
                        if (_k == 'EH:oznaka_da_je_podpis_veljaven_neveljaven') {
                          _this.nodeData.properties[_k].push(_v ? parseInt(_v) : null);
                        } else {
                          _this.nodeData.properties[_k].push(_v ? _v : '');
                        }
                    });
                });

                console.log("_this.nodeData", _this.nodeData);
            },

            async getNode(nodeId) {
                const _this = this;

                await axios.get(config.alfrescoCoreApi + 'nodes/' + nodeId)
                    .then((res) => {

                        console.log(res);
                        _this.nodeData = res.data.entry;


                        _this.isLoading = false;
                        console.log("nodeData: ", _this.nodeData);
                        this.initialDocumentStatus = this.nodeData.properties["EH:status_gradiva"];
                        if( _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'pdf' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'image' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'audio' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'video') {
                            _this.isLoading = false;
                        } else {
                            _this.isLoading = false;
                            _this.isLoadingPreview = true;
                        }


                        //_this.componentTags = _this.nodeData.properties['EH:komponenta_povezave_na_dokumente'];
                        _.map(_this.nodeData.properties['EH:komponenta_povezave_na_dokumente'], function(val){
                            _this.componentTags.push({
                                text: val
                            });
                        });

                        console.log("_this.componentTags",_this.componentTags);


                        // join separated signature data to array of signature objects
                        let epodpisi = null;
                        let steviloEpodpisov = 0;

                        _.each(_this.$store.getters.getAlfrescoDictionary, function(v, k){
                            if(v.name === 'EH:e_podpis') {
                                console.log("v", v);
                                epodpisi = v.properties;
                            }
                        });

                        steviloEpodpisov =  _this.nodeData.properties['EH:stevilo_podpisov'];
                        delete epodpisi['EH:stevilo_podpisov'];


                        for(let i = 0; i < steviloEpodpisov; i++) {
                            let podpis = {};
                            _.forOwn(epodpisi, function (v, k){
                                console.log("k", k, "v", _this.nodeData.properties[k][i]);
                                podpis[k] = _this.nodeData.properties[k][i];
                            });
                            _this.podpisi.push(podpis);
                        }
                        _this.cancelEditingEsignature();
                        console.log("PODPISI", _this.podpisi);

                        for(let aspect of _this.eHrambaAspectsDictionary){
                            if((!_this.nodeData.properties['EH:komponenta_povezave_na_dokumente'] || (_this.nodeData.properties['EH:komponenta_povezave_na_dokumente']
                                && aspect.name === 'EH:komponenta')) && aspect.title !== 'E-podpis' && aspect.name !== 'EH:verzioniranje' && aspect.name !== 'EH:verzija_type' && aspect.name !== 'EH:verzija'
                                && aspect.name !== 'EH:porocilo' && aspect.name !== 'EH:pretvorjeno_gradivo' && aspect.name !== 'EH:pretvorba_za_dolgorocno_hrambo' && aspect.name !== 'EH:pretvorjeno_gradivo_assoc_aspect'){

                                let aspectPropertiesKeys = Object.keys(aspect.properties);

                                for(let key of aspectPropertiesKeys) {

                                    if(_this.nodeData.properties[key]){
                                        _this.isPropertyChecked[key] = true;
                                        _this.isPropertyCheckboxDisabled[key] = false;
                                    }
                                    else{
                                        _this.isPropertyCheckboxDisabled[key] = true;
                                    }

                                }

                            }

                        }


                    })
                    .catch((error) => {
                        console.error(error);

                        _this.isLoading = false;
                    });


            },

            selectDate(selectedDate) {
                const _this = this;
                console.log("selectedDate", selectedDate);
                _this.$forceUpdate(); // workaround to force update VueCtkDateTimePicker component
            },

            save() {
                const _this = this;
                _this.isLoading = true;
                let data = _this.nodeData;

                console.log("SAVE!!!!");

              _this.prepareEsignatureDataForPost();


                // convert long and int string to int + remove null items
                _.each(data.properties, function (val, key) {
                    _.forOwn(data.types, function(_val){
                        if(_val.properties[key] && (_val.properties[key].dataType === 'd:long' || _val.properties[key].dataType === 'd:int')) {
                            if(val !== null && val !== '') {
                                data.properties[key] = parseInt(val);
                            } else if(val == '') {
                                data.properties[key] = null;
                            }
                        }
                    });

                    // remove all items where value is null on empty string
                    if(data.properties[key] === null || data.properties[key] === "") {
                        delete data.properties[key]
                    }

                });

                if(!data.propertiesToBeDeleted){
                    data.propertiesToBeDeleted = [];
                }

                let isPropertyCheckedKeys = Object.keys(this.isPropertyChecked);

                for(let key of isPropertyCheckedKeys) {
                    if(this.isPropertyChecked[key] == false) {
                        data.propertiesToBeDeleted.push(key);

                        delete data.properties[key];
                    }
                }

                if(_this.podpisi.length > 0) {
                    data.properties['EH:stevilo_podpisov'] = _this.podpisi.length;
                } else if(_this.eSignatureDeleted){
                  data.properties["EH:gradivo_e_podpisano"] = false;
                  data.properties["EH:stevilo_podpisov"] = null;
                  data.properties["EH:oznaka_da_je_podpis_veljaven_neveljaven"] = null;
                  data.properties["EH:ime_in_priimek_podpisnika"] = null;
                  data.properties["EH:datum_in_ura_podpisa"] = null;
                  data.properties["EH:casovni_zig"] = null;
                  data.properties["EH:cas_vnosa_podatka"] = null;
                  data.properties["EH:izdajatelj_certifikata"] = null;
                  data.properties["EH:stevilka_certifikata"] = null;
                  data.properties["EH:velja_od"] = null;
                  data.properties["EH:velja_do"] = null;
                  data.properties["EH:cas_preverjanja_elektronskega_podpisa"] = null;
                }


                let types = _.filter(_this.$store.getters.getAlfrescoDictionary, function (v, k) {

                    if (_this.nodeData.aspectNames.indexOf(v.name) > -1 && v.name.substring(0, 4) !== 'rma:') {
                        return true
                    } else {
                        return false
                    }
                });

                data.types = types;

                //data = '{"isFile":true,"createdByUser":{"id":"povezan_sistem","displayName":"povezan_sistem"},"modifiedAt":"2020-02-18T10:07:25.934+0000","nodeType":"cm:content","content":{"mimeType":"text/plain","mimeTypeName":"Plain Text","sizeInBytes":28901,"encoding":"UTF-8"},"parentId":"f4475f2e-79e2-4f0b-a4be-7a6b444ffbca","aspectNames":["rn:renditioned","cm:versionable","cm:thumbnailModification","rma:recordOriginatingDetails","rma:recordComponentIdentifier","EH:komponenta","cm:ownable","rma:commonRecordDetails","cm:titled","rma:filePlanComponent","cm:auditable","cm:author","rma:recordSearch","rma:record"],"createdAt":"2020-02-18T10:07:25.934+0000","isFolder":false,"modifiedByUser":{"id":"povezan_sistem","displayName":"povezan_sistem"},"name":"macki_report__20171217-0339 (2020-1582020446462).txt","id":"03b66738-59e4-47bb-a7d7-a0a844feeda0","properties":{"cm:title":"macki_report__20171217-0339.txt","cm:versionType":"MAJOR","cm:versionLabel":"1.0","rma:recordOriginatingCreationDate":"2020-02-18T10:07:26.444+0000","rma:identifier":"2020-1582020446462","cm:owner":{},"rma:recordSearchHasDispositionSchedule":false,"EH:komponenta_povezave_na_dokumente":["72717f7c-dcfe-4542-9717-3b718114f4b2","813bca83-23dc-468a-b5fb-541bde50009b"],"caa11cb8-1d24-4e15-882f-f7e1d88644cc"],"cm:lastThumbnailModification":["doclib:1582020447630","pdf:1582036560249"],"rma:origionalName":"macki_report__20171217-0339.txt","rma:recordOriginatingLocation":"1ce68e80-25c5-4e99-bf1f-7c9aae15c570","rma:rootNodeRef":"f7e77d95-5fe6-4de1-863c-3bbd667ff384","rma:recordOriginatingUserId":"povezan_sistem"},"types":[{"name":"cm:versionable","isAspect":true,"isContainer":false,"title":"Versionable","description":"Versionable","parent":{},"defaultAspects":{},"properties":{"cm:autoVersionOnUpdateProps":{"name":"cm:autoVersionOnUpdateProps","title":"Auto Version - on update properties only","description":"","dataType":"d:boolean","defaultValue":"false","multiValued":false,"mandatory":false,"enforced":false,"protected":false,"indexed":true,"url":"/api/classes/cm_versionable/property/cm_autoVersionOnUpdateProps"},"cm:versionLabel":{"name":"cm:versionLabel","title":"Version Label","description":"Version Label","dataType":"d:text","defaultValue":null,"multiValued":false,"mandatory":false,"enforced":false,"protected":true,"indexed":true,"url":"/api/classes/cm_versionable/property/cm_versionLabel"},"cm:autoVersion":{"name":"cm:autoVersion","title":"Auto Version","description":"Auto Version","dataType":"d:boolean","defaultValue":"true","multiValued":false,"mandatory":false,"enforced":false,"protected":false,"indexed":true,"url":"/api/classes/cm_versionable/property/cm_autoVersion"},"cm:versionType":{"name":"cm:versionType","title":"Version Type","description":"","dataType":"d:text","defaultValue":null,"multiValued":false,"mandatory":false,"enforced":false,"protected":true,"indexed":true,"url":"/api/classes/cm_versionable/property/cm_versionType"},"cm:initialVersion":{"name":"cm:initialVersion","title":"Initial Version","description":"Initial Version","dataType":"d:boolean","defaultValue":"true","multiValued":false,"mandatory":false,"enforced":false,"protected":false,"indexed":true,"url":"/api/classes/cm_versionable/property/cm_initialVersion"}},"associations":{},"childassociations":{},"url":"/api/classes/cm_versionable"},{"name":"cm:thumbnailModification","isAspect":true,"isContainer":false,"title":"Thumbnail Modification Data","description":"","parent":{},"defaultAspects":{},"properties":{"cm:lastThumbnailModification":{"name":"cm:lastThumbnailModification","title":"Last thumbnail modifcation data","description":"","dataType":"d:text","defaultValue":null,"multiValued":true,"mandatory":false,"enforced":false,"protected":false,"indexed":true,"url":"/api/classes/cm_thumbnailModification/property/cm_lastThumbnailModification"}},"associations":{},"childassociations":{},"url":"/api/classes/cm_thumbnailModification"},{"name":"cm:author","isAspect":true,"isContainer":false,"title":"Author","description":"Author","parent":{},"defaultAspects":{},"properties":{"cm:author":{"name":"cm:author","title":"Author","description":"Author","dataType":"d:text","defaultValue":null,"multiValued":false,"mandatory":false,"enforced":false,"protected":false,"indexed":true,"url":"/api/classes/cm_author/property/cm_author"}},"associations":{},"childassociations":{},"url":"/api/classes/cm_author"},{"name":"cm:ownable","isAspect":true,"isContainer":false,"title":"Ownable","description":"Ownable","parent":{},"defaultAspects":{},"properties":{"cm:owner":{"name":"cm:owner","title":"Owner","description":"Owner","dataType":"d:text","defaultValue":null,"multiValued":false,"mandatory":false,"enforced":false,"protected":false,"indexed":true,"url":"/api/classes/cm_ownable/property/cm_owner"}},"associations":{},"childassociations":{},"url":"/api/classes/cm_ownable"},{"name":"cm:auditable","isAspect":true,"isContainer":false,"title":"Auditable","description":"Auditable","parent":{},"defaultAspects":{},"properties":{"cm:creator":{"name":"cm:creator","title":"Creator","description":"Who created this item","dataType":"d:text","defaultValue":null,"multiValued":false,"mandatory":true,"enforced":true,"protected":true,"indexed":true,"url":"/api/classes/cm_auditable/property/cm_creator"},"cm:created":{"name":"cm:created","title":"Created Date","description":"Created Date","dataType":"d:datetime","defaultValue":null,"multiValued":false,"mandatory":true,"enforced":true,"protected":true,"indexed":true,"url":"/api/classes/cm_auditable/property/cm_created"},"cm:modifier":{"name":"cm:modifier","title":"Modifier","description":"Who last modified this item","dataType":"d:text","defaultValue":null,"multiValued":false,"mandatory":true,"enforced":true,"protected":true,"indexed":true,"url":"/api/classes/cm_auditable/property/cm_modifier"},"cm:modified":{"name":"cm:modified","title":"Modified Date","description":"When this item was last modified","dataType":"d:datetime","defaultValue":null,"multiValued":false,"mandatory":true,"enforced":true,"protected":true,"indexed":true,"url":"/api/classes/cm_auditable/property/cm_modified"},"cm:accessed":{"name":"cm:accessed","title":"Last Accessed Date","description":"When this item was last accessed","dataType":"d:datetime","defaultValue":null,"multiValued":false,"mandatory":false,"enforced":false,"protected":true,"indexed":true,"url":"/api/classes/cm_auditable/property/cm_accessed"}},"associations":{},"childassociations":{},"url":"/api/classes/cm_auditable"},{"name":"EH:komponenta","isAspect":true,"isContainer":false,"title":"Komponenta eHramba gradiva","description":"Dokument je komponenta drugega gradiva\\n            ","parent":{},"defaultAspects":{},"properties":{"EH:komponenta_povezave_na_dokumente":{"name":"EH:komponenta_povezave_na_dokumente","title":"Gradiva IDs","description":"Seznam alfresco nodeId vrednosti dokumentov, katerim ta dokument predstavlja komponento","dataType":"d:text","defaultValue":null,"multiValued":true,"mandatory":false,"enforced":false,"protected":false,"indexed":true,"url":"/api/classes/EH_komponenta/property/EH_komponenta_povezave_na_dokumente"}},"associations":{},"childassociations":{},"url":"/api/classes/EH_komponenta"},{"name":"cm:titled","isAspect":true,"isContainer":false,"title":"Titled","description":"Titled","parent":{},"defaultAspects":{},"properties":{"cm:title":{"name":"cm:title","title":"Title","description":"Content Title","dataType":"d:mltext","defaultValue":null,"multiValued":false,"mandatory":false,"enforced":false,"protected":false,"indexed":true,"url":"/api/classes/cm_titled/property/cm_title"},"cm:description":{"name":"cm:description","title":"Description","description":"Content Description","dataType":"d:mltext","defaultValue":null,"multiValued":false,"mandatory":false,"enforced":false,"protected":false,"indexed":true,"url":"/api/classes/cm_titled/property/cm_description"}},"associations":{},"childassociations":{},"url":"/api/classes/cm_titled"},{"name":"rn:renditioned","isAspect":true,"isContainer":true,"title":"Renditioned","description":"","parent":{},"defaultAspects":{},"properties":{},"associations":{},"childassociations":{"rn:rendition":{"name":"rn:rendition","title":"","url":"/api/classes/rn_renditioned/association/rn_rendition","source":{"class":"rn:renditioned","mandatory":false,"many":true},"target":{"class":"cm:content","mandatory":false,"many":true}}},"url":"/api/classes/rn_renditioned"}]}';

                console.log("DATA!:", data);


                axios.post(config.demoVpisnik + 'metadata/' + _this.nodeData.id, data)
                    .then((res) => {
                        //_this.getNode(_this.nodeData.id);
                        _this.$router.replace({name: 'DocumentDetails', params: {id: _this.nodeData.id}});
                        //_this.$router.go(-1);

                        this.isLoading = false;
                        Vue.$toast.open({
                            message: 'Gradivo uspešno urejeno!',
                            type: 'success',
                            position: 'top-right'
                        });


                    })
                    .catch((error) => {
                        console.error(error);
                        this.isLoading = false;

                        Vue.$toast.open({
                            message: 'Napaka pri nalaganju na strežnik.',
                            type: 'error',
                            position: 'top-right'
                        });
                    });


            },

            checkIfCodeList(propertyName) {
                const _this = this;
                let isCodeList = false;

                _.each(_this.allMetadataOptions, function (val, key) {
                    let property = val.property;

                    if(propertyName === property) {
                        isCodeList = true;
                        return false;
                    }
                });

                return isCodeList;

            },

            getCodeListOptions(propertyName) {
                const _this = this;
                let options = [];

                _.each(_this.allMetadataOptions, function (val, key) {
                    let property = val.property;

                    if(propertyName === property) {
                        options = val.body;
                        return false;
                    }
                });

                return options
            },

            changeDocumentStatus(status) {

                let _this = this;
                this.isLoading = true;
                //1 (Delovni) ali 2 (Koncni)

                axios.post(config.reopenRecord,{}, {
                    params: {
                        nodeId: this.fileId,
                        documentStatus: status
                    }} )
                    .then((res) => {
                        //_this.getNode(_this.nodeData.id);
                        //_this.$router.go(-1);
                        _this.$router.replace({name: 'DocumentDetails', params: {id: _this.nodeData.id}});
                        _this.isLoading = false;
                        Vue.$toast.open({
                            message: 'Gradivo uspešno urejeno!',
                            type: 'success',
                            position: 'top-right'
                        });


                    })
                    .catch((error) => {
                        console.error(error);
                        this.isLoading = false;

                        Vue.$toast.open({
                            message: 'Napaka pri nalaganju na strežnik.',
                            type: 'error',
                            position: 'top-right'
                        });
                    });

            },

            onComponentTagsChanged(newTags) {
                const _this = this;

                console.log("newTags", newTags);


                let tags = [];
                _.map(_this.componentTags, function (val) {
                    tags.push(val.text.trim());
                });
                _this.nodeData.properties['EH:komponenta_povezave_na_dokumente'] = tags;

            },

            onLinksToLeadingDocumentTagsChanged(newTags) {
                const _this = this;

                console.log("newTags", newTags);


                let tags = [];
                _.map(_this.linksToLeadingDocumentTags, function (val) {
                    console.log(val)
                    tags.push(val.text.trim());
                });
                _this.nodeData.properties['EH:povezave_na_vodilne_dokumente'] = tags;

            },

            premestiArhiviranoEnotoGradiva() {
              const _this = this;
              let data = {
                "nodeId": _this.nodeData.id,
                "targetClass": _this.premestitevArhiviraneEnoteNovRazred
              };

              _this.isLoading = true;

              axios.post(config.rootEhramba + 'moveClosedRecord', data, )
                  .then((res) => {

                    _this.isLoading = false;

                    Vue.$toast.open({
                      message: 'Gradivo uspešno prmeščeno v razred z oznako ' + _this.premestitevArhiviraneEnoteNovRazred + '!',
                      type: 'success',
                      position: 'top-right'
                    });

                    _this.showPremestitevArhiviraneEnoteGradiva = false;
                    _this.premestitevArhiviraneEnoteNovRazred = null;

                    _this.getNode(_this.nodeData.id);


                  })
                  .catch((error) => {
                    console.error(error);
                    this.isLoading = false;

                    Vue.$toast.open({
                      message: 'Napaka pri premeščanju.',
                      type: 'error',
                      position: 'top-right'
                    });
                  });
            }

        }


    };
</script>



// WEBPACK FOOTER //
// src/pages/DocumentDetailsEditTestClient.vue